<template>
	<div class="col-12 col-md-11 offset-md-1">
		<!-- scrollTo is scroll point for pagination change-->
		<Breadcrumbs class="col-12"/>
		<h1 id="scrollTo" class="title">{{title}}</h1>
		<p class="col-12 savings">
			{{savings}}
		</p>
	</div>
</template>

<script>

import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";

export default {
	name: 'ListingHeader',
	props: ["title", "savings"],
	components: {
		Breadcrumbs
	}
}
</script>

<style lang="scss" scoped>
	.savings {
		font-size: 1.25rem;
		text-align: center;
	}
	.title {
		text-align: center;
	}
</style>
